// import Layout from '@/views/login/index'
// demo 可删除
export default [
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Layout,
  //   redirect: '/login/personal',
  //   children: [
  //     {
  //       name: 'login_personal',
  //       path: 'personal',
  //       component: () => import('@/views/login/personal/index')
  //     },
  //     {
  //       name: 'login_company',
  //       path: 'company',
  //       component: () => import('@/views/login/company/index')
  //     }
  //   ],
  //   hidden: true
  // }
]
